import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITicketGuideFormModel } from './ticket-guide.component';
import { IOrderSearchResult } from '../../shared/services/order/order-search-data.service';

@Component({
  selector: 'order-search-result',
  template: `
    <table class="table" id="order-results">
      <thead>
        <tr>
          <th translate>APP.TICKET.TABLEHEADER.CUST_PO</th>
          <th translate>APP.TICKET.TABLEHEADER.ORDER</th>
          <th translate>APP.TICKET.TABLEHEADER.ETA</th>
          <th translate>APP.TICKET.TABLEHEADER.STATUS</th>
          <th translate>APP.TICKET.TABLEHEADER.WEBSHOP</th>
          <th translate>APP.TICKET.TABLEHEADER.COUNTRY</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let order of orders">
          <td>
            <input type="radio" name="orderId" [(ngModel)]="model.orderId" [value]="order.id" (change)="onOrderIdChange.emit(order)" (click)="onOrderIdChange.emit(order)" [disabled]="checkSOWBusy"/> &nbsp;
            <span>{{order.poNumber}}</span>
          </td>
          <td>{{order.id}}</td>
          <td>{{order.etaDate}}</td>
          <td>{{order.status}}</td>
          <td>{{order.webshop}}</td>
          <td>{{order.country}}</td>
        </tr>
      </tbody>
    </table>
  `
})
export class OrderSearchResultComponent {
  @Input() public model: ITicketGuideFormModel;
  @Input() public checkSOWBusy: boolean;
  @Input() public orders: IOrderSearchResult[];
  @Output() public onOrderIdChange: EventEmitter<IOrderSearchResult> = new EventEmitter<IOrderSearchResult>();
}